import { HOLIDAYS, THANKSGIVING, CHRISTMAS_EVE, hostsByYear, hostFor } from '../data/schedule'

// Everything here works in local time on purpose. "Is Thanksgiving over yet?"
// is a question about the calendar on the wall, not about UTC, and a family
// spread across time zones should each see their own answer.

export const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())

// Fourth Thursday in November.
export const thanksgivingDate = (year) => {
  const firstOfNovember = new Date(year, 10, 1)
  const daysToFirstThursday = (4 - firstOfNovember.getDay() + 7) % 7
  return new Date(year, 10, 1 + daysToFirstThursday + 21)
}

export const christmasEveDate = (year) => new Date(year, 11, 24)

export const dateOf = (holidayKey, year) => (
  holidayKey === THANKSGIVING ? thanksgivingDate(year) : christmasEveDate(year)
)

export const scheduledYears = (holidayKey) => Object.keys(hostsByYear[holidayKey] || {})
  .map(Number)
  .sort((a, b) => a - b)

export const lastScheduledYear = () => Math.max(
  ...HOLIDAYS.flatMap((holiday) => scheduledYears(holiday.key))
)

export const daysBetween = (from, to) => Math.round(
  (startOfDay(to) - startOfDay(from)) / 86400000
)

export const countdownLabel = (days) => {
  if (days === 0) return 'today'
  if (days === 1) return 'tomorrow'
  return `in ${days} days`
}

const occurrence = (holiday, year, today) => {
  const date = dateOf(holiday.key, year)
  return {
    ...holiday,
    year,
    date,
    host: hostFor(holiday.key, year),
    daysAway: daysBetween(today, date)
  }
}

// The holidays still ahead of us, soonest first. A holiday counts as upcoming
// all through its own day - you still want the address on the morning of.
export const upcomingHolidays = (today, count = 2) => {
  const thisYear = today.getFullYear()
  return [thisYear, thisYear + 1, thisYear + 2]
    .flatMap((year) => HOLIDAYS.map((holiday) => occurrence(holiday, year, today)))
    .filter((entry) => entry.daysAway >= 0)
    .sort((a, b) => a.date - b.date)
    .slice(0, count)
}

// Every year on the books, both holidays, oldest first. No "today" involved -
// this is what the published feed is built from at deploy time.
export const allScheduledOccurrences = () => HOLIDAYS
  .flatMap((holiday) => scheduledYears(holiday.key).map((year) => ({
    ...holiday,
    year,
    date: dateOf(holiday.key, year),
    host: hostFor(holiday.key, year)
  })))
  .sort((a, b) => a.date - b.date)

export const scheduleFor = (holidayKey, today) => {
  const thisYear = today.getFullYear()
  const holiday = HOLIDAYS.find((entry) => entry.key === holidayKey)
  return scheduledYears(holidayKey).map((year) => ({
    ...occurrence(holiday, year, today),
    isPast: dateOf(holidayKey, year) < startOfDay(today),
    isCurrentYear: year === thisYear
  }))
}

export const formatHolidayDate = (date) => date.toLocaleDateString('en-US', {
  weekday: 'long', month: 'long', day: 'numeric'
})

export { THANKSGIVING, CHRISTMAS_EVE, HOLIDAYS, hostFor }
